
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import ContactMap from './components/ContactMap';

export default function ContactPage() {
  useEffect(() => {
    document.title = 'Contact High Standards Smoke Shop - Visit Us in Eustis Florida';
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'Contact High Standards Smoke Shop',
      description:
        'Get in touch with High Standards Smoke Shop in Eustis, Florida. Visit us at 1321 S Bay St or call +1 352 977-4832.',
      url: `${siteUrl}/contact`,
      isPartOf: {
        '@type': 'WebSite',
        name: 'High Standards Smoke Shop',
        url: siteUrl,
      },
      mainEntity: {
        '@type': 'LocalBusiness',
        name: 'High Standards Smoke Shop',
        telephone: '+13529774832',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '1321 S Bay St',
          addressLocality: 'Eustis',
          addressRegion: 'FL',
          postalCode: '32726',
          addressCountry: 'US',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 28.8528,
          longitude: -81.6851,
        },
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            opens: '10:00',
            closes: '20:00',
          },
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Sunday'],
            opens: '09:00',
            closes: '22:00',
          },
        ],
        sameAs: [
          'https://www.instagram.com/highstandardsmoke?igsh=MXd0YTRobGI0MWUzZw%3D%3D',
          'https://www.tiktok.com/@highstandards.smokes',
        ],
        hasMap: 'https://maps.google.com/?q=1321+S+Bay+St,+Eustis,+FL+32726',
      },
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-contact';
    script.textContent = JSON.stringify(schema);
    const existing = document.getElementById('schema-contact');
    if (existing) existing.remove();
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-contact');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="bg-deep-black min-h-screen">
      <Navbar />
      <main>
        <ContactHero />
        <ContactForm />
        <ContactInfo />
        <ContactMap />
      </main>
      <Footer />
    </div>
  );
}
